import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'

const { FormSelect } = window.M

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data
  }
}

class ConnectedAccountFilters extends React.Component {
  constructor() {
    super()
    this.state={
      statusSelect: null
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  componentDidMount() {
    const el = document.getElementById("filterStatus")
    const statusSelect = FormSelect.init(el)

    this.setState({ statusSelect: statusSelect })
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters } = this.state
    const oldFilters = prevState.filters

    if (JSON.stringify(oldFilters) !== JSON.stringify(filters)) {
      console.log(filters)
      Object.keys(filters).forEach( filter => {
        const key=`localFilters.${filter}`
        this.formDispatch(actions.change(key, filters[filter]));
      })
    }

  }

  handleSubmit(values) {
    console.log(values)
    this.props.setFilters(values)
  }

  render(){

    return (
      <table className="bordered striped highlight responsive-table users-list">
        <tbody>
          <tr className="userFilters">
            <td>
              <LocalForm
                model="localFilters"
                getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                onSubmit = { (values) => {
                  this.handleSubmit(values)
                }}
                onChange = { (values) => {
                  this.handleSubmit(values)
                }}
                initialState={{
                  name: "",
                  description: "",
                  status: ""
                }}
              >
                <div className="row" title="Use criteria to filter accounts">

                  <div className="input-field col s12 l4 xl4">
                    <label className="alwaysActive" htmlFor="filterName">Filter by Name</label>
                    <Control.text id="filterName" model=".name" />
                  </div>

                  <div className="input-field col s12 l4 xl4">
                    <label className="alwaysActive" htmlFor="filterData">Filter by Description</label>
                    <Control.text id="filterDescription" model=".description" />
                  </div>

                  <div className="input-field col s12 l4 xl4">
                    <label className="active" htmlFor="filterStatus">Filter by Status</label>
                    <Control.select id="filterStatus" className="roleSelect" model=".status" onChange={(e) => {
                      e.preventDefault()
                    }}>
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="disabled">Disabled</option>
                    </Control.select>
                  </div>

                </div>
              </LocalForm>
            </td>
          </tr>
        </tbody>
      </table>

    )
  }
}

const AccountFilters = connect(mapStateToProps)(ConnectedAccountFilters)

export default AccountFilters



// WEBPACK FOOTER //
// ./src/js/components/AccountFilters.js